import styled from 'styled-components'

export const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

export const ModalContainer = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 480px;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-family: 'Segoe UI', sans-serif;
`

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #666;
`

export const Title = styled.h2`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 24px;
`

export const Steps = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-left: 0;
  margin: 0;
`

export const Step = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`

export const StepTitle = styled.p`
  font-weight: bold;
  margin: 0;
  font-size: 15px;
`

export const StepText = styled.p`
  margin: 4px 0 0 0;
  font-size: 14px;
  color: #444;
`

export const TipBox = styled.div`
  background-color: #eef5ff;
  color: #1a57c2;
  font-size: 14px;
  margin-top: 24px;
  padding: 12px;
  border-radius: 8px;
  line-height: 1.5;
`

export const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-top: 2px;
  .span {
   color: 'white',
   fontWeight: 'bold',
   fontSize: '14px'
}
`
